<template>
    <div class="page">
        <div class="page-content">
            <div class="header-box">
                <div class="header-box-item">
                    <div class="my-charts" ref="charts1"></div>
                </div>
                <div class="header-box-item">
                    <div class="my-charts" ref="charts2"></div>
                </div>
                <div class="header-box-item">
                    <div class="my-charts" ref="charts3"></div>
                </div>
                <div class="header-box-item">
                    <div class="my-charts" ref="charts4"></div>
                </div>
            </div>
            <div class="bottom-box">
                <div class="left-bottom-box">

                </div>
                <div class="right-bottom-box" style="margin-top: 20px">
                    <div class="my-charts" ref="charts6"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts';
    import { get } from '@/utils/request';

    export default {
        data(){
            return{

            }
        },
        created() {
            setTimeout(()=>{
                this.initChart1();
                this.initChart2();
                this.initChart3();
                this.initChart4();
                this.initChart6();
            },1000)
        },
        methods:{
            initChart1(){
                let charts1 = echarts.init(this.$refs.charts1);
                charts1.setOption({
                    color: [ '#ff7070'],
                    title: {
                        text: '今日收款',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            // emphasis: {
                            //     label: {
                            //         show: true,
                            //         fontSize: 40,
                            //         fontWeight: 'bold'
                            //     }
                            // },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 1048, name: 'Search Engine' },
                            ]
                        }
                    ]
                })
            },

            initChart2(){
                let charts2 = echarts.init(this.$refs.charts2);
                charts2.setOption({
                    color: [ '#5470c6'],
                    title: {
                        text: '统计数据2',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 40,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 735, name: 'Direct' },
                            ]
                        }
                    ]
                })
            },

            initChart3(){
                let charts3 = echarts.init(this.$refs.charts3);
                charts3.setOption({
                    color: [ '#fac858'],
                    title: {
                        text: '统计数据3',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 40,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 580, name: 'Email' },
                            ]
                        }
                    ]
                })
            },
            initChart4(){
                let charts4 = echarts.init(this.$refs.charts4);
                charts4.setOption({
                    color: [ '#95d278'],
                    title: {
                        text: '统计数据4',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    series: [
                        {
                            name: 'Access From',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: false,
                            label: {
                                show: false,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: 40,
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: 484, name: 'Union Ads' },
                            ]
                        }
                    ]
                })
            },
            initChart6(){
                let charts6 = echarts.init(this.$refs.charts6);
                charts6.setOption({
                    title: {
                        text: '统计数据6',
                        left: 'center'
                    },
                    tooltip: {
                        trigger: 'axis'
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                    toolbox: {
                        feature: {
                            saveAsImage: {}
                        }
                    },
                    xAxis: {
                        type: 'category',
                        boundaryGap: false,
                        data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: 'Email',
                            type: 'line',
                            stack: 'Total',
                            data: [120, 132, 101, 134, 90, 230, 210]
                        },
                        {
                            name: 'Union Ads',
                            type: 'line',
                            stack: 'Total',
                            data: [220, 182, 191, 234, 290, 330, 310]
                        },
                        {
                            name: 'Video Ads',
                            type: 'line',
                            stack: 'Total',
                            data: [150, 232, 201, 154, 190, 330, 410]
                        },
                        {
                            name: 'Direct',
                            type: 'line',
                            stack: 'Total',
                            data: [320, 332, 301, 334, 390, 330, 320]
                        },
                        {
                            name: 'Search Engine',
                            type: 'line',
                            stack: 'Total',
                            data: [820, 932, 901, 934, 1290, 1330, 1320]
                        }
                    ]
                })
            },
        }
    }
</script>

<style lang="scss">

.my-charts{
    width: 100%;
    height: 100%;
}

.header-box{
    display: flex;
    flex-direction: row;

    .header-box-item{
        flex: 1;
        height: 300px;
        border-right: 1px solid #e4eaec;

        &:last-child{
            border-right: none;
        }
    }
}

.bottom-box{
    width: 100%;
    height: 548px;
    border-top: 1px solid #e4eaec;
    display: flex;
    flex-direction: row;

    .left-bottom-box{
        flex: 1;
        border-right: 1px solid #e4eaec;
    }

    .right-bottom-box{
        flex: 3;
    }
}
</style>